<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width="500" content-class="round-2xl")
  v-card
    v-card-text.py-6.px-10
      .text-xl.font-semibold.neutral700--text.text-center Thank you for your interest in our {{ feature }} feature! 😊
      v-card.mt-10(outlined)
        div.neutral200.fill-height.pa-5
          .text-md.font-medium.neutral700--text.text-center Let us know you are interested in this feature and we will set up a demo session accordingly. Press submit to confirm
    v-divider
    v-card-actions.pa-3
      v-spacer
      y-button.mr-3(label="Cancel" size="sm" text @click="closeDialog")
      y-button(label="Submit" size="sm" @click="submit")

</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true
    },
    feature: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    submit() {
      window.open(this.link, '_blank')
    },
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    }
  }
}
</script>
